import { createRoot } from 'react-dom/client'
import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import {
  departureDate,
  scheduleType,
  activitesList,
} from '../actions/dive-operator-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
} from '../actions/main-actions'

import {
  dslFiltersState,
  queryFilters,
  scheduleIsShown,
} from '../actions/dsl-dive-center-actions'
import {
  currencyDirective,
  collapseItems,
  openToggler,
  openContactCenter,
  diveGuidesHeaderFooter,
  commentTooltip,
} from '../directives'
import { getLanguage, getTranslations } from 'utils'
import 'babel-polyfill'
import 'whatwg-fetch'

import HeroLightbox from '../components/liveaboard/HeroLightbox'
import ErrorHandler from '../components/ErrorHandler'
import ActivitiesList from '../components/dive-center/CardsDsl/OtherActivitiesList'
import Schedule from '../components/dive-center/ScheduleDSL'
// import Distance from '../components/dive-center/Distance'
import WhereToDive from '../components/dive-guides/map/WhereToDive'
import WidgetActivites from '../components/dive-center/WidgetActivities'
import AdventuresWidget from '../components/dive-center/AdventuresWidget'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import CalendarContainer from '../components/dive-center/DslMarineLifeCalendar/CalendarContainer'
import CoursesList from '../components/dive-center/CardsDsl/CoursesList'
import TranslationRating from '../components/helpers/translationRating/TranslationRating'

// import OtherGroupTrips from '../components/group-trips/OtherGroupTrips'
// import PriceConverter from '../components/helpers/PriceConverter'
// import BackSectionTime from '../components/dive-center/BackSectionTime'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

let store = createStore(
  combineReducers({
    pageLoader,
    selectedCurrency,
    departureDate,
    scheduleType,
    activitesList,
    dslFiltersState,
    queryFilters,
    scheduleIsShown,
  }),
)

let language = getLanguage()
let messages = {}

window.operatorStore = store
window.store = store
configure(store)

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }

  renderElement('translate_rating', TranslationRating, {
    translationIds: window.translationIds,
  })

  renderElement('hero-lightbox', HeroLightbox, {
    photos: window.photos,
    videos: window.videos,
  })

  renderElement('courses', CoursesList, {
    diveCenterId: window.diveCenterId,
    courseFilters: window.courseFilters,
    isWidget: window.isWidget,
    type: 'courses',
    wechatQr: window.wechatQr,
    renderElement: renderElement,
  })

  renderElement('other-activities', ActivitiesList, {
    diveCenterId: window.diveCenterId,
    courseFilters: window.courseFilters,
    isWidget: window.isWidget,
    type: 'other',
  })

  renderElement('where-to-dive', WhereToDive, {
    pins: [
      ...(window.divePlaces || []),
      {
        ...window.diveCenterPoints,
        pinType: 'diveShop',
      },
    ],
    pinType: 'diveSite',
    showWidget: true,
    locationBounds: window.locationBounds,
    isTravelMap: true,
    isDiveCenter: true,
    countryCode: window.countryCode,
  })

  renderElement('schedule', Schedule, {
    diveCenterId: window.diveCenterId,
    isBookableActivitiesExists: window.isBookableActivitiesExists,
  })

  renderElement('marine-life', CalendarContainer, {
    data: window.marineLife,
  })

  // renderElement('other-diveoperators', OtherGroupTrips, window.shop)
  // renderElement('back-section-departure', BackSectionTime)
  //
  renderElement('diving-items', WidgetActivites, {
    diveCenterId: window.diveCenterId,
  })
  renderElement('adventure-items', AdventuresWidget, {
    diveCenterId: window.diveCenterId,
    adventureTypes: window.adventureTypes,
    isAdventuresOnly: window.isAdventuresOnly,
  })
  // renderElement('diving', ActivitiesList, {
  //   diveCenterId: window.diveCenterId,
  //   type: 'dive-trips',
  // })
  // renderElement('distance', Distance, {
  //   distanceToUser: window.distanceToUser,
  // })
  // renderElement('minimum-price', PriceConverter, { amount: +window.shop.minimumPrice, currency: window.shop.currency })
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  openToggler()
  collapseItems()
  openContactCenter(renderElement)
  diveGuidesHeaderFooter()
  commentTooltip(renderElement)
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
